import { render, staticRenderFns } from "./ClothSystem.vue?vue&type=template&id=527931cc&scoped=true&lang=pug&"
import script from "./ClothSystem.ts?vue&type=script&lang=ts&"
export * from "./ClothSystem.ts?vue&type=script&lang=ts&"
import style0 from "./ClothSystem.vue?vue&type=style&index=0&id=527931cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527931cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VDivider,VIcon})
